import React from "react";
import PageContainer from "../../../components/PageContainer/PageContainer";
import { Button, colors } from "@repo/ui";
import { useMediaQuery } from "react-responsive";
import EventDetails from "../components/AsideSection/EventDetails";
import undoIcon from "../../../assets/icons/undo.svg";
import { useNavigate } from "react-router-dom";
import TabNavigation from "../../../components/TabNavigation/TabNavigation";
import ShareTabContent from "../components/ShareTabContent/ShareTabContent";
import BackButton from "../../../components/BackButton";
import { useTranslation } from "react-i18next";
import { withTranslations } from "../../../hoc/withTranslations/withTranslations";
import TwoColumnLayout from "../../../components/TwoColumnLayout/TwoColumnLayout";

const LOCALE = "modules_MyGiftTable_pages_ShareTable";

const ShareTableWeb: React.FC = () => {
  const { t } = useTranslation(LOCALE);
  const navigate = useNavigate();

  return (
    <PageContainer startColor={colors.background} endColor="white">
      <div className="p-0 md:p-8 w-[100vw]">
        <TwoColumnLayout
          aside={
            <>
              <EventDetails />
              <Button
                className="w-full"
                type="secondary"
                onClick={() => navigate("/my-table")}
                label={
                  <div className="flex items-center justify-between">
                    <span>{t("backToMyTable")}</span>
                    <img
                      src={undoIcon}
                      alt={t("backAlt")}
                      className="ml-2 h-4 w-4"
                    />
                  </div>
                }
              />
            </>
          }
          asideWidth="clamp(300px, 15vw, 10%)"
        >
          <TabNavigation
            tabs={[
              { label: t("shareMyTable"), component: <ShareTabContent /> },
            ]}
          />
        </TwoColumnLayout>
      </div>
    </PageContainer>
  );
};

const ShareTableMobile: React.FC = () => {
  const { t } = useTranslation(LOCALE);
  const navigate = useNavigate();

  return (
    <PageContainer startColor={colors.background} endColor="white">
      <div className="flex flex-col p-0 w-screen">
        {/* Back arrow */}
        <div className="flex items-center p-4">
          <BackButton text={t("back")} onClick={() => navigate("/my-table")} />
        </div>
        <main className="flex-1 w-screen">
          <TabNavigation
            tabs={[
              { label: t("shareMyTable"), component: <ShareTabContent /> },
            ]}
          />
        </main>
      </div>
    </PageContainer>
  );
};

const ShareTable: React.FC = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  return isMobile ? <ShareTableMobile /> : <ShareTableWeb />;
};

export default withTranslations(LOCALE)(ShareTable);
